import { NoSsr } from '@cian/react-utils';
import * as React from 'react';

import { getPrettyChatDate } from '../../utils/prettyDate';
import { Caption } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';

interface IChatPrettyDateProps {
  date: number;
  showOnlyTime?: boolean;
  showTime?: boolean;
  showFullDateWithTime?: boolean;
  color?: TColors;
}

export const ChatPrettyDate: React.FC<IChatPrettyDateProps> = ({
  date,
  showOnlyTime,
  showTime,
  showFullDateWithTime,
  color,
}) => {
  const [prettyDate, setPrettyDate] = React.useState('');

  React.useEffect(
    () =>
      setPrettyDate(
        getPrettyChatDate(date, {
          showFullDateWithTime,
          showOnlyTime,
          showTime,
        }),
      ),
    [date, showFullDateWithTime, showOnlyTime, showTime],
  );

  return (
    <NoSsr>
      <Caption color={color}>{prettyDate}</Caption>
    </NoSsr>
  );
};
